import {css} from "@panda/css";

import {BrandMedalIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {navigationLinks} from "@pg-rp/navigation";

import {doesVendorHaveAnniversaryAward} from "../../../helpers/does_vendor_have_anniversary_award";
import {getVendorAnniversaryAwardPrice} from "../../../helpers/VendorAnniversaryAwardType";
import {IVendorDetail} from "../../../types/IVendorDetail";

const {anniversaryPGLink} = navigationLinks;

interface IProps {
    vendor: IVendorDetail;
}

export const VendorDetailReportModalContentAwards = (props: IProps) => {
    const {vendor} = props;
    const vendorAward = doesVendorHaveAnniversaryAward(vendor);

    if (!vendorAward) {
        return null;
    }

    return (
        <div className={subHeaderContainerStyle}>
            <div className={subHeaderStyle}>
                <BrandMedalIcon size="3" />
                <Text variant="mini_header">NAGRODY I WYRÓŻNIENIA</Text>
            </div>
            <div className={awardsContainerStyle}>
                <Text variant="headline_6">Nagrody Jubileuszowe</Text>
                <Text variant="info_txt_1" mb={2}>
                    {vendor.name} otrzymał nagrodę w kategorii <span>{getVendorAnniversaryAwardPrice(vendor.id)}</span>
                </Text>
                <Link href={anniversaryPGLink} className={anniversaryLinkStyle}>
                    Dowiedz się więcej
                </Link>
            </div>
        </div>
    );
};

const anniversaryLinkStyle = css({
    textDecoration: "underline"
});

const awardsContainerStyle = css({
    border: "solid 1px var(--colors-gray-500)",
    mb: 3,
    p: 1,

    md: {
        p: 3,
        mb: 6
    }
});

const subHeaderStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 3,
    mb: 4
});

const subHeaderContainerStyle = css({
    mb: 6,

    md: {
        mb: 10
    }
});
import {css} from "@panda/css";

import {BrandMedalIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {navigationLinks} from "@pg-rp/navigation";

import {doesVendorHaveAnniversaryAward} from "../../../helpers/does_vendor_have_anniversary_award";
import {getVendorAnniversaryAwardPrice} from "../../../helpers/VendorAnniversaryAwardType";
import {IVendorDetail} from "../../../types/IVendorDetail";

const {anniversaryPGLink} = navigationLinks;

interface IProps {
    vendor: IVendorDetail;
}

export const VendorDetailReportModalContentAwards = (props: IProps) => {
    const {vendor} = props;
    const vendorAward = doesVendorHaveAnniversaryAward(vendor);

    if (!vendorAward) {
        return null;
    }

    return (
        <div className={subHeaderContainerStyle}>
            <div className={subHeaderStyle}>
                <BrandMedalIcon size="3" />
                <Text variant="mini_header">NAGRODY I WYRÓŻNIENIA</Text>
            </div>
            <div className={awardsContainerStyle}>
                <Text variant="headline_6">Nagrody Jubileuszowe</Text>
                <Text variant="info_txt_1" mb={2}>
                    {vendor.name} otrzymał nagrodę w kategorii <span>{getVendorAnniversaryAwardPrice(vendor.id)}</span>
                </Text>
                <Link href={anniversaryPGLink} className={anniversaryLinkStyle}>
                    Dowiedz się więcej
                </Link>
            </div>
        </div>
    );
};

const anniversaryLinkStyle = css({
    textDecoration: "underline"
});

const awardsContainerStyle = css({
    border: "solid 1px var(--colors-gray-500)",
    mb: 3,
    p: 1,

    md: {
        p: 3,
        mb: 6
    }
});

const subHeaderStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 3,
    mb: 4
});

const subHeaderContainerStyle = css({
    mb: 6,

    md: {
        mb: 10
    }
});
